export enum MonitoringPageType {
  Transports = 'transports',
  AutomotiveAftermarket = 'automotive-aftermarket',
  TransportManagement = 'transport-management',
  Shipments = 'shipments',
  DemurrageAndDetention = 'demurrage-and-detention',
  UliList = 'uli-list',
  UliOverview = 'uli-overview',
}
